module.exports = __webpack_public_path__ + "static/media/close-button.aaeab23b.svg";